<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="结存月份"><el-date-picker v-model="query.month" type="month" size="small" value-format="yyyy-MM" /></el-form-item>
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:monthlyBalance:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('inventory:monthlyBalance:list')" type="primary" size="small" @click="exportFile">导出</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
        <el-button v-if="isAuth('inventory:monthlyBalance:list')" type="warning" size="small" @click="rebuildSelectedMonth">重建所选月份</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="balanceMonth" label="结存月份" width="120" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" />
      <el-table-column prop="materialName" label="产品名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
      <el-table-column v-if="inventoryQtyShowSupplier" prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
      <el-table-column prop="wareHousePath" label="仓库库位" min-width="180" show-overflow-tooltip />
      <el-table-column prop="beginQuantity" label="期初" width="110" align="right" />
      <el-table-column prop="inQuantity" label="入库" width="110" align="right" />
      <el-table-column prop="outQuantity" label="出库" width="110" align="right" />
      <el-table-column prop="endQuantity" label="期末" width="110" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin, monthText } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'
export default {
  name: 'MonthlyBalance',
  mixins: [authMixin, inventoryQtyShowSupplierMixin],
  data() { return { query: { month: monthText(-1), materialCode: '', materialName: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false } },
  created() { this.loadInventoryQtyShowSupplierPolicy(); this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { month: monthText(-1), materialCode: '', materialName: '' }; this.search() },
    load() {
      if (!this.query.month) { this.$message.warning('请选择结存月份'); return }
      this.loading = true
      request.get('/inventory/monthlyBalance/list', { params: { month: this.query.month, materialCode: this.query.materialCode, materialName: this.query.materialName, pageIndex: this.pageIndex, pageSize: this.pageSize } })
        .then(res => {
          const body = res.data || {}
          this.rows = body.list || []
          this.total = body.totalCount || 0
        }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    exportFile() {
      if (!this.query.month) { this.$message.warning('请选择结存月份'); return }
      request.get('/inventory/monthlyBalance/export', { params: { month: this.query.month, materialCode: this.query.materialCode, materialName: this.query.materialName }, responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '库存月结存.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => {})
    },
    rebuildSelectedMonth() {
      if (!this.query.month) { this.$message.warning('请选择结存月份'); return }
      const month = this.query.month
      this.$confirm(`将按每日结存重新生成 ${month} 的月结存，确定继续吗？`, '重建月结存', { type: 'warning' }).then(() => {
        request.post('/inventory/monthlyBalance/rebuild', { balanceMonth: month }).then(() => {
          this.$message.success(`${month} 月结存重建完成`)
          this.search()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
